<template>
  <v-layout row wrap>
    <v-flex xs12 md8 v-if="!getProfileHaveClient">
      <v-card>
        <v-card-title>
          <span class="headline">Служба физических лиц.</span>
        </v-card-title>
        <v-card-text>
          Служба физических лиц позволяет сохранять информацию о физических лицах необходимыхдля деятельности компании. Физические лица могут быть сотрудниками компании или представителями контрагентов, данные о которых хранятся в компании.
          Для работы с физическими лицами , необходимо определить Юридическое лицо которое Вы представляете.
          Регистрируйтесь и общайтесь от имени Вашей компании.        </v-card-text>
        <v-card-actions>
          <v-btn to="/register">Регистрация</v-btn>
        </v-card-actions>   
      </v-card>
    </v-flex>
    <v-flex xs12 md8 v-if="getProfileHaveClient && !this.$route.params.personId">
      <v-people-set></v-people-set>
    </v-flex>
    <v-flex xs12 md8 v-if="getProfileHaveClient && $route.params.personId">
      <v-person-page :itemId="$route.params.personId"></v-person-page>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex'
  import vPeopleSet from './PeopleSet.vue'
  import vPersonPage from './PersonPage.vue'

  export default {
    name: 'people-panel',
    components: {vPeopleSet, vPersonPage},
    props: {
    },
    data: () => ({
    }),
    created () {
    },
    mounted () {
    },
    watch: {
    // в случае изменения маршрута запрашиваем данные вновь
    },
    computed: {
      ...mapGetters({
        getProfileHaveClient: 'getProfileHaveClient'
      })
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// PeoplePanel.vue?4d58485b